
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"vuesax/twotone/timer","xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#8d98aa"}},[_c('path',{attrs:{"d":"M9.375 1.719h-3.75a.469.469 0 01-.469-.469.469.469 0 01.469-.469h3.75a.469.469 0 01.469.469.469.469 0 01-.469.469z","opacity":".4"}}),_c('path',{attrs:{"data-name":"Vector","d":"M7.344 2.344a5.938 5.938 0 11-5.938 5.938 5.944 5.944 0 015.938-5.938zm0 10.938a5 5 0 10-5-5 5.006 5.006 0 005 5z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M9.373 10.489a.467.467 0 01-.24-.066L7.437 9.407a1.681 1.681 0 01-.764-1.339V5.826a.469.469 0 01.469-.469.469.469 0 01.469.469v2.242a.75.75 0 00.306.539l1.7 1.012a.469.469 0 01-.241.871z","opacity":".4"}})])])
          )
        }
      }
    